import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { FormField } from 'ui/formField';
import { useFormState } from 'react-hook-form';
import { BorderedRadioListField } from 'lib/iterable-hook-form';

// x8 creates three column layout (if three items), if two is preferred use x12
const FlexContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${spacing.x8}, 1fr));
  gap: ${spacing.half} ${spacing.double};
`;

export type ConnectedInputFieldProps = {
  labelText?: string;
  name: string;
  onClick?: () => void;
  options: any[];
  disabled?: boolean;
};

export const AccountTypesRadioListField = ({
  labelText,
  name,
  options,
  ...props
}: ConnectedInputFieldProps) => {
  const { errors } = useFormState();
  const inputId = `${name}-input`;
  const errorText = (errors[name]?.message || '') as string;

  return (
    <FormField
      inputId={inputId}
      labelText={labelText}
      errorText={errorText}
      hasError={Boolean(errorText)}
    >
      <FlexContainer>
        {options?.map((option) => (
          <BorderedRadioListField
            key={option.id}
            name={name}
            options={[option]} // Designs show a whole field for each option,
            {...props}
          />
        ))}
      </FlexContainer>
    </FormField>
  );
};
